import React, { useState, useEffect } from "react";
import axiosInstance from "utils/axiosInstance";
import { Box, Typography, Chip, CircularProgress, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const HealthCheck = () => {
  const [healthStatus, setHealthStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHealthStatus = async () => {
      try {
        const response = await axiosInstance.get("/health");
        setHealthStatus(response.data); // Assuming the response has a "status" field
        setError(null); // Clear any previous errors
      } catch (err) {
        const errorMessage =
          err.response?.data?.message || "Service Unavailable";
        setError(errorMessage);
        setHealthStatus(null); // Reset health status if there's an error
      } finally {
        setLoading(false);
      }
    };

    // Perform an initial health check
    fetchHealthStatus();

    // Set up interval to fetch health status every 1 minute
    const interval = setInterval(fetchHealthStatus, 60000 * 5); // 60000ms = 1 minute

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 150,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 3, textAlign: "center" }}>
      <Typography>
        Health Check
      </Typography>      
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Alert severity={healthStatus?.status === "healthy" ? "success" : "error"}>
          Status: <strong>{healthStatus?.status === "healthy" ? "healthy" : "unhealthy"}</strong>
        </Alert>
      )}
    </Box>
  );
};

export default HealthCheck;
